import React from 'react'
import { Link } from 'react-router-dom';
import { useModal } from '../../../contexts/ModalContext';

export default function MediaCTA() {
    const { openQueryModal } = useModal();
  return (
    <>
      <section className='mediadetail-cta'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='mediadetail-box'>
                <h2 className='heading'>See Mobility Infotech in Action</h2>
                <p>500+ businesses worldwide use Mobility Infotech to cut costs, optimize routes, and scale their logistics operations smarter.</p>
                <div className='media-detail-cta-btn'>
                  <Link className="theme-btn white-btn" onClick={openQueryModal}> <span>Start Your Demo</span>
                  </Link>
                  <Link className="theme-btn" onClick={openQueryModal}> <span>Read Success Stories</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
